import { render } from "./ParcelaPix.vue?vue&type=template&id=13eb1c84"
import script from "./ParcelaPix.vue?vue&type=script&lang=js"
export * from "./ParcelaPix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__